export default __webpack_public_path__ + "static/media/neil-img-home.b4599731.png";